import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { ISortingData } from "../../../components/src/SortingTableHeader";
import { IFilter } from "../../../components/src/FilterPopover";
import { getFiterList, makeApiMessage } from "../../../components/src/common";
// Customizable Area Start
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  checkIsFilterApplied,
  customPermissionApiKey
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";

export interface IPermanentTag {
  id: number;
  type: "permanent_tag";
  attributes: {
    tag_code: string;
    prefix: string;
    number: number;
    status: string;
    assigned_at: string | null;
    created_at: string;
    updated_at: string;
    metadata: object;
  };
  relationships: {
    catalogues_service: {
      data: {
        id: number;
        type: string;
        price: string;
        sqm_price: string;
        weight_price: string;
        is_default: boolean;
      };
    };
    catalogue_variant: {
      data: {
        id: number;
        type: string;
        catalogue_id: number;
        active: boolean;
      };
    };
    catalogue: {
      data: {
        id: number;
        type: string;
        name: string;
        sku: string | null;
        description: string | null;
      };
    };
    service: {
      data: {
        id: number;
        type: string;
        name: string;
        second_name: string;
        short_name: string;
      };
    };
  };
}

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
}

export interface IAddTagForm {
  prefix: string;
  number: string;
  catalogue_id: string;
  service_id: string;
  status: string;
}

export interface ICustomerHistory {
  customer_account_id: number;
  customer_name: string;
  customer_email: string;
  customer_phone: string;
  usage_count: number;
  last_used_at: string;
  last_used_store: {
    id: number;
    store_id: string;
    store_name: string;
  } | null;
  last_used_order_invoice_number: string | null;
}

export interface ICustomerUsageHistoryResponse {
  permanent_tag: {
    id: number;
    tag_code: string;
    status: string;
  };
  customer_history: ICustomerHistory[];
  total_customers: number;
  total_usages: number;
}

export interface S {
  drawerWidth: number;
  popOverOpened: boolean;
  popOverItemId: string;
  popOverItemStatus: string;
  popOverTop: number;
  popOverLeft: number;
  hoveredButton: string;
  permanentTags: IPermanentTag[];
  page: number;
  pageSize: number;
  sortingData: ISortingData;
  query: string;
  filterAnchor: any;
  filters: IFilter[];
  searchText: string;
  suggestionFieldTitle: string;
  permissionStatus: PermissionStatus;
  isLoading: boolean;
  isAppliedFilter: boolean;
  openViewDialog: boolean;
  selectedTag: IPermanentTag | null;
  openAddDialog: boolean;
  addTagForm: IAddTagForm;
  isSubmitting: boolean;
  openCustomerHistoryDialog: boolean;
  customerHistoryData: ICustomerUsageHistoryResponse | null;
  isLoadingCustomerHistory: boolean;
}

export interface SS {
  id: any;
}

const emptyTag: IPermanentTag = {
  id: 0,
  type: "permanent_tag",
  attributes: {
    tag_code: "",
    prefix: "",
    number: 0,
    status: "",
    assigned_at: null,
    created_at: "",
    updated_at: "",
    metadata: {}
  },
  relationships: {
    catalogues_service: {
      data: {
        id: 0,
        type: "",
        price: "",
        sqm_price: "",
        weight_price: "",
        is_default: false
      }
    },
    catalogue_variant: {
      data: {
        id: 0,
        type: "",
        catalogue_id: 0,
        active: false
      }
    },
    catalogue: {
      data: {
        id: 0,
        type: "",
        name: "",
        sku: null,
        description: null
      }
    },
    service: {
      data: {
        id: 0,
        type: "",
        name: "",
        second_name: "",
        short_name: ""
      }
    }
  }
};

export default class PermanentTagsListController extends BlockComponent<Props, S, SS> {
  getTagsCallId: string = "";
  updateTagCallId: string = "";
  deleteTagCallId: string = "";
  createTagCallId: string = "";
  filterSuggestionApiCallId: string = "";
  customerUsageHistoryCallId: string = "";
  tableRefs: HTMLElement | null = null;

  constructor(props: Props) {
    super(props);

    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.SearchTextMessage),
      getName(MessageEnum.LayoutDataMessage)
    ];
    this.receive = this.receive.bind(this);

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    this.state = {
      popOverOpened: false,
      drawerWidth: 0,
      popOverItemStatus: "",
      popOverLeft: 0,
      hoveredButton: "",
      permanentTags: [],
      popOverTop: 0,
      page: 0,
      popOverItemId: "",
      pageSize: 25,
      sortingData: {
        tag_code: "",
      },
      query: "",
      searchText: "",
      suggestionFieldTitle: "",
      filters: [
        {
          title: "Tag Code",
          type: "autocompolete",
          value: "",
          options: [],
        },
      ],
      filterAnchor: false,
      permissionStatus: {
        mainPermission: false,
        createPermission: false,
        viewPermission: false,
        editPermission: false,
        deactivatePermission: false,
        activatePermission: false
      },
      isLoading: false,
      isAppliedFilter: false,
      openViewDialog: false,
      selectedTag: null,
      openAddDialog: false,
      addTagForm: {
        prefix: "",
        number: "",
        catalogue_id: "",
        service_id: "",
        status: "available"
      },
      isSubmitting: false,
      openCustomerHistoryDialog: false,
      customerHistoryData: null,
      isLoadingCustomerHistory: false
    };
  }

  processMeta = (message: Message) => {
    const responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
    const perPage = responseJson.meta.per_page || 10;

    let newTags = Array<IPermanentTag>(responseJson.meta.total_count);
    for (let i = 0; i < responseJson.meta.total_count; i++) {
      if (
        i >= (responseJson.meta.current_page - 1) * perPage &&
        i < responseJson.meta.current_page * perPage
      ) {
        newTags[i] = responseJson.data[i - (responseJson.meta.current_page - 1) * perPage];
      } else {
        if (!this.state.permanentTags[i] || !this.state.permanentTags[i].id) newTags[i] = { ...emptyTag };
      }
    }
    this.setState({ permanentTags: newTags });
  };

  async receive(from: string, message: Message) {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      const responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      if (apiRequestCallId === this.getTagsCallId) {
        this.handleTagsListDataResp(responseJson, message);
      } else if (apiRequestCallId === this.updateTagCallId) {
        this.getTags();
      } else if (apiRequestCallId === this.deleteTagCallId) {
        this.getTags();
      } else if (apiRequestCallId === this.createTagCallId) {
        this.handleCreateTagResponse(responseJson);
      } else if (apiRequestCallId === this.filterSuggestionApiCallId) {
        if (responseJson) {
          const updatedFilters = getFiterList(
            responseJson,
            this.state.filters,
            this.state.suggestionFieldTitle
          );
          this.setState({ filters: updatedFilters });
        }
      } else if (apiRequestCallId === this.customerUsageHistoryCallId) {
        this.handleCustomerUsageHistoryResponse(responseJson);
      }
    }

    this.retrieveSearchTextData(message);
    this.receiveDataFromLayout(message);
  }

  createData(tagCode: string, productName: string, serviceName: string, status: string, id: string) {
    return { tagCode, productName, serviceName, status, id };
  }

  handleDrawerWidthChange = (width: number) => {
    this.setState({ drawerWidth: width });
  };

  getTags = () => {
    this.setState({ isLoading: true });
    const header = {
      "Content-Type": configJSON.contentType,
      token: window.localStorage.getItem(configJSON.tokenKey),
    };
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getTagsCallId = getDataMsg.messageId;

    const tagCodeFilter = this.state.filters.find((item) => item.title === "Tag Code")?.value;
    const searchText = this.state.searchText;

    let url =
      configJSON.permanentTagsListApi +
      "?page_no=" +
      (this.state.page + 1) +
      (tagCodeFilter ? `&filter_by[tag_code]=${tagCodeFilter}` : "") +
      (searchText ? `&search=${searchText}` : "") +
      this.state.query;

    getDataMsg.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), url);
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  handleTagsListDataResp = (responseJson: any, message: Message) => {
    if (responseJson) {
      if (responseJson.meta) {
        this.setState({ isLoading: false });
        this.processMeta(message);
      } else {
        let tags = responseJson.data as IPermanentTag[];
        tags = tags.filter((el) => el.attributes);
        this.setState({ isLoading: false, permanentTags: tags });
      }
    }
  };

  updateTag = (tagId: string, isActive: boolean) => {
    const header = {
      "Content-Type": configJSON.contentType,
      token: window.localStorage.getItem(configJSON.tokenKey),
    };

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.updateTagCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.permanentTagsListApi + "/" + tagId + "/" + (isActive ? "activate" : "deactivate")
    );
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "PUT");

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  deleteTag = (tagId: string) => {
    const header = {
      "Content-Type": configJSON.contentType,
      token: window.localStorage.getItem(configJSON.tokenKey),
    };

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.deleteTagCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.permanentTagsListApi + "/" + tagId
    );
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "DELETE");

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleDeleteTag = (tagId: string) => {
    this.setState({ popOverOpened: false });
    this.deleteTag(tagId);
  };

  async componentDidMount() {
    super.componentDidMount();
    this.handleStorageFilter();
  }

  handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    page: number
  ) => {
    if (page !== this.state.page) {
      this.setState({ page }, () => this.getTags());
    }
  };

  handleSearch = (value: string) => {
    this.setState(
      {
        page: 0,
        searchText: value,
      },
      this.getTags
    );
  };

  handleAddTag = () => {
    this.setState({ openAddDialog: true });
  };

  handleCloseAddDialog = () => {
    this.setState({
      openAddDialog: false,
      addTagForm: {
        prefix: "",
        number: "",
        catalogue_id: "",
        service_id: "",
        status: "available"
      }
    });
  };

  handleAddTagFormChange = (field: keyof IAddTagForm, value: string) => {
    this.setState({
      addTagForm: {
        ...this.state.addTagForm,
        [field]: value
      }
    });
  };

  handleCreateTag = () => {
    const { addTagForm } = this.state;

    if (!addTagForm.prefix || !addTagForm.number || !addTagForm.catalogue_id || !addTagForm.service_id) {
      return;
    }

    this.setState({ isSubmitting: true });

    const header = {
      "Content-Type": configJSON.contentType,
      token: window.localStorage.getItem(configJSON.tokenKey),
    };

    const body = {
      permanent_tag: {
        prefix: addTagForm.prefix,
        number: parseInt(addTagForm.number, 10),
        catalogue_id: parseInt(addTagForm.catalogue_id, 10),
        service_id: parseInt(addTagForm.service_id, 10),
        status: addTagForm.status,
        metadata: {}
      }
    };

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.createTagCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.permanentTagsListApi
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(body)
    );
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "POST");

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleCreateTagResponse = (responseJson: any) => {
    this.setState({ isSubmitting: false });
    if (responseJson && !responseJson.errors) {
      this.handleCloseAddDialog();
      this.getTags();
    }
  };

  handleEditTag = (tagId: string) => {
    this.setState({ popOverOpened: false });
    this.props.navigation.history.push("/Settings-General-PermanentTagsEdit?tagId=" + tagId);
    window.localStorage.setItem("tagId", tagId);
  };

  handleViewTag = (tagId: string) => {
    const selectedTag = this.state.permanentTags.find(tag => String(tag.id) === tagId) || null;
    this.setState({
      popOverOpened: false,
      openViewDialog: true,
      selectedTag
    });
  };

  handleCloseViewDialog = () => {
    this.setState({
      openViewDialog: false,
      selectedTag: null
    });
  };

  handleDeactivate = () => {
    this.setState({ popOverOpened: false });
    this.updateTag(this.state.popOverItemId, false);
  };

  handleActivateTag = () => {
    this.setState({ popOverOpened: false });
    this.updateTag(this.state.popOverItemId, true);
  };

  handleQueryChange = (query: string) => {
    this.setState({ query }, () => this.getTags());
  };

  sortingProps = {
    onChange: (sortingData: ISortingData) => this.setState({ sortingData }),
    onQueryChange: (query: string) => this.handleQueryChange(query),
    width: "22%",
  };

  handleFilterChange = (filters: IFilter[]) => {
    if (checkIsFilterApplied(filters)) {
      localStorage.setItem("permanent_tags_filter_value", JSON.stringify(filters));
    } else {
      localStorage.removeItem("permanent_tags_filter_value");
    }

    this.setState(
      { filters, isAppliedFilter: checkIsFilterApplied(filters) },
      this.getTags
    );
  };

  handleAutoComplete = (title: string, value: string) => {
    this.state.filters.forEach((item: IFilter) => {
      if (item.title === title) item.value = value;
      return item;
    });

    let ApiUrl;
    if (title === "Tag Code") {
      ApiUrl = configJSON.tagCodeFilterSuggEndPoint;
    }

    let requestMessage = makeApiMessage({
      url: ApiUrl + value,
      method: "GET",
    });
    this.filterSuggestionApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.permanentTagPermission;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForNewPermissonStatus(apiKey, userData as Array<PermissionGroupArray>);
    this.setState({
      permissionStatus: value
    });
  };

  retrieveSearchTextData = (message: Message) => {
    if (message.id === getName(MessageEnum.SearchTextMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.SearchMessageText)
      );
      if (recievedData) {
        this.handleSearch(recievedData.searchText);
      }
    }
  };

  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if (recievedData.userContext) {
        this.handleUserChange(recievedData.userContext);
      }
    }
  };

  handleReturnColorType = () => {
    const { isAppliedFilter } = this.state;
    return isAppliedFilter ? "primary" : "inherit";
  };

  handleStorageFilter = () => {
    const applied_filter = localStorage.getItem("permanent_tags_filter_value");
    if (applied_filter) {
      this.setState(
        {
          filters: JSON.parse(applied_filter),
          isAppliedFilter: checkIsFilterApplied(JSON.parse(applied_filter)),
        },
        () => this.getTags()
      );
    } else {
      this.getTags();
    }
  };

  getCustomerUsageHistory = (tagId: string) => {
    this.setState({ isLoadingCustomerHistory: true, openCustomerHistoryDialog: true });

    const header = {
      "Content-Type": configJSON.contentType,
      token: window.localStorage.getItem(configJSON.tokenKey),
    };

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.customerUsageHistoryCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.customerUsageHistoryApi}?permanent_tag_id=${tagId}`
    );
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleCustomerUsageHistoryResponse = (responseJson: any) => {
    this.setState({ isLoadingCustomerHistory: false });
    if (responseJson && responseJson.data) {
      this.setState({ customerHistoryData: responseJson.data });
    }
  };

  handleCloseCustomerHistoryDialog = () => {
    this.setState({
      openCustomerHistoryDialog: false,
      customerHistoryData: null
    });
  };

  formatLastUsedDate = (dateString: string) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };
  // Customizable Area End
}
